import { WithStyles, withStyles } from "@material-ui/core/styles";
import { ThemeOptions } from "@material-ui/core/styles/createTheme";
import update from "immutability-helper";
import * as React from "react";
import { RouteComponentProps, RouterProps } from "react-router";
import { Route, Switch } from "react-router-dom";
import {
  ISanitizedSchool,
  ISurveyRespondentResponse,
  ResponseSource,
  TemplateQuestionCategory,
} from "src/services";
import Component from "../components/Component";
import withAxios, { IAxiosProps } from "../components/withAxios";
import { IUser } from "src/services";
import ChooseCoachPage from "./respondent/ChooseCoachPage";
import EnterCodePage from "./respondent/EnterCodePage";
import NameInputPage from "./respondent/NameInputPage";
import SurveyRespondPage from "./respondent/SurveyRespondPage";
// import { IUser } from "src/services";
const styles = () => ({
  content: {
    padding: 20,
  },
});

export interface ISchoolState {
  name: string;
  tagline: string;
  logo1: string;
  logo2: string;
  mascot:string;
  id:any;
}
const emptySchoolState = {
  logo1: "",
  logo2: "",
  name: "",
  tagline: "",
  mascot:"",
  id:""
};

export interface IRespondentPagePassedDown {
  responseSource: number;
  loadSurvey: (code: string) => void;
  loadingSurvey?: boolean;
  surveyResponse: ISurveyRespondentResponse | undefined;
  finishedSurveySections: IFinishedSurveySection[];
  school: ISchoolState;
}

interface IRespondentPageProps {
  responseSource: ResponseSource;
  setTheme: (theme: ThemeOptions) => void;
}

type IProps = IRespondentPageProps &
  RouterProps &
  IAxiosProps &
  WithStyles<keyof ReturnType<typeof styles>>;

export interface IFinishedSurveySection {
  coachId: number;
  code: string;
}

interface IRespondentPageState {
  loadingSurvey?: true;
  finishedSurveySections: IFinishedSurveySection[];
  respondentName: string;
  school: ISchoolState | undefined;
  surveyResponse: ISurveyRespondentResponse | undefined;
  showVideo: boolean,
  url: string,
  forVideoMidSeson:boolean,
  showDelayedVideo: boolean, 
  forJvCoach:boolean,
  schoolMidseason: boolean;
    schoolData:any;
}

export default withStyles(styles)(
  withAxios(
    class RespondentPage extends Component<IProps, IRespondentPageState> {
      public readonly state = this.buildState({
        finishedSurveySections: [],
        respondentName: "",
        school: undefined,
        surveyResponse: undefined,
        showVideo: false,
        url: "",
        forVideoMidSeson:false,
        showDelayedVideo: false, 
        forJvCoach:false,
        schoolMidseason: false,
          schoolData:""
      });

      private readonly respondentNameChange = this.stateInputEventHandler(
        (v) => ({ respondentName: v.replace(/ +(?= )/g, "") })
      );

      public render() {
        const { responseSource } = this.props;
        const responsePath =
          responseSource === ResponseSource.coach
            ? "teacher"
            : ResponseSource[responseSource];
        // console.log("this.state", this.state)
        // console.log("isAdSurvey", this.state.schoolData.isAdSurvey)

        // console.log("this.props", this.props)
        
        return (
          <>
            <Switch>
              <Route
                path={`/${responsePath}/:code/:coachId/inputNamePage`}
                component={this.ParamsExtractingNameInputPage}
              />
              <Route
                path={`/${responsePath}/:code/:coachId/:category/:section`}
                component={this.ParamsExtractingSurveyRespondPage}
              />
              <Route
                path={`/${responsePath}/:code/:coachId/:category`}
                component={this.ParamsExtractingSurveyRespondPage}
              />
              <Route
                path={`/${responsePath}/:code`}
                component={this.ParamsExtractingChooseCoachPage}
              />
              <Route
                path={`/${responsePath}`}
                component={this.ParamsEnterCodePage}
              />
            </Switch>
          </>
        );
      }
      public async componentDidUpdate(prevProps: IProps, prevState: IRespondentPageState) {
        if (!prevState.school && this.state.school) {
            const res: any = await this.buildGet<IUser>(this, "user")();
            const resofschool: any = await this.buildGet<IUser>(this, `/school/getOneSchools/${this.state.school.id}`)()
            this.setState({schoolMidseason: resofschool?.data?.ismidseason, schoolData:resofschool?.data})            
            const hhheadcoch = await this.buildPost<{userId: any, schoolId: any}, any>(
                this, "/coaches/getHeadCoach"
            )({
                userId: res?.id,
                schoolId: this.state.school.id,
            });
    
            console.log("meadseson res:::", hhheadcoch);
            if(hhheadcoch?.data?.type === "head" && hhheadcoch?.data !== null){
              this.setState({ forVideoMidSeson: true});
            }    
            if((hhheadcoch?.data?.type === "coach") && hhheadcoch?.data !== null){
              this.setState({ forJvCoach: true});
            }
            if (!hhheadcoch?.status) {
              setTimeout(() => {
                this.setState({ showDelayedVideo: true });
              }, 2000); // delay in case of false
            } else {
              this.setState({ showDelayedVideo: true });
            }
        }
    }
    

      private ParamsExtractingNameInputPage = ({
        match,
        history,
      }: RouteComponentProps<{
        code: string;
        coachId: string;
        category: string;
        section: string;
      }>) => {
        const { code, coachId } = match.params;
        const { responseSource } = this.props;
        const {
          surveyResponse,
          loadingSurvey,
          finishedSurveySections,
          respondentName,
          school,
          forVideoMidSeson
        } = this.state;
        // TODO make this a function that I can take from somewhere
        const parsedCoachId = parseInt(coachId, 10);
        return (
          <NameInputPage
          schoolData={this.state.schoolData}
            history={history}
            responseSource={responseSource}
            loadSurvey={this.loadSurvey}
            loadingSurvey={loadingSurvey}
            surveyResponse={surveyResponse}
            finishedSurveySections={finishedSurveySections}
            code={code}
            school={school !== undefined ? school : emptySchoolState}
            respondentNameChange={this.respondentNameChange}
            respondentName={respondentName}
            coachId={isNaN(parsedCoachId) ? undefined : parsedCoachId}
            forVideoMidSeson= {forVideoMidSeson}
          />
        );
      };

      private ParamsExtractingSurveyRespondPage = ({
        match,
        history,
      }: RouteComponentProps<{
        code: string;
        coachId: string;
        category: string;
        section: string;
      }>) => {
        const { code, coachId, category, section } = match.params;
        const { responseSource } = this.props;
        const {
          surveyResponse,
          loadingSurvey,
          finishedSurveySections,
          school,
          respondentName,
          forVideoMidSeson
        } = this.state;
        // TODO make this a function that I can take from somewhere
        const parsedCoachId = parseInt(coachId, 10);
        // also force the category amount to be between 0 and category length
        const categoryLength = Object.keys(TemplateQuestionCategory).length / 2;
        const parsedCategoryId = Math.min(
          Math.max(0, parseInt(category, 10)),
          categoryLength
        );
        const parsedSectionId = Math.min(Math.max(0, parseInt(section, 10)), 1);
        return (
          <SurveyRespondPage
           schoolData={this.state.schoolData}
            collectRespondentName={this.getCollectRespondentName()}
            history={history}
            respondentName={respondentName}
            responseSource={responseSource}
            loadSurvey={this.loadSurvey}
            loadingSurvey={loadingSurvey}
            surveyResponse={surveyResponse}
            finishedSurveySections={finishedSurveySections}
            code={code}
            coachId={isNaN(parsedCoachId) ? undefined : parsedCoachId}
            category={isNaN(parsedCategoryId) ? 2 : parsedCategoryId}
            section={isNaN(parsedSectionId) ? 2 : parsedSectionId}
            finishedSurveySectionPush={this.finishedSurveySectionPush}
            school={school !== undefined ? school : emptySchoolState}
            forVideoMidSeson={forVideoMidSeson}
          />
        );
      };

      private ParamsExtractingChooseCoachPage = ({
        match,
      }: RouteComponentProps<{ code: string }>) => {
        const { code } = match.params;
        const { responseSource } = this.props;
        const {
          surveyResponse,
          loadingSurvey,
          finishedSurveySections,
          school,
        } = this.state;
        return (
          <ChooseCoachPage
          schoolData={this.state.schoolData}
            collectRespondentName={this.getCollectRespondentName()}
            responseSource={responseSource}
            loadSurvey={this.loadSurvey}
            loadingSurvey={loadingSurvey}
            surveyResponse={surveyResponse}
            finishedSurveySections={finishedSurveySections}
            code={code}
            school={school !== undefined ? school : emptySchoolState}
          />
        );
      };

      private ParamsEnterCodePage = ({ history }: RouteComponentProps<{}>) => {
        const { responseSource } = this.props;
        return (
          <EnterCodePage responseSource={responseSource} history={history}  schoolData={this.state.schoolData}/>
        );
      };

      private finishedSurveySectionPush = (
        finishedSurveySection: IFinishedSurveySection
      ) => {
        this.setState((prevState) =>
          update(prevState, {
            finishedSurveySections: {
              $push: [finishedSurveySection],
            },
          })
        );
      };
      // load the survey here from code. Also only load if the code does not match the current stuff
      private loadSurvey = (code: string): void =>
        void this.runCancellableStatefulAsync(
          this,
          {
            loadingSurvey: true,
          },
          {
            loadingSurvey: undefined,
          },
          async () => {
            const {
              responseSource,
              // history,
            } = this.props;
            const { surveyResponse } = this.state;
            // only reload survey if the survey isn't already loaded.
            // this will prevent things from changing for no reason.
            if (
              surveyResponse !== undefined &&
              surveyResponse.survey !== undefined &&
              surveyResponse.survey.code === code
            ) {
              // no need to reload the same survey because they can't change
              return;
            }
            const survey = await this.buildGet<ISurveyRespondentResponse>(
              this,
              `survey/respondent/${responseSource}/${code}`
            )();
            console.log("code========>", responseSource)
            this.setState({ surveyResponse: survey });
            this.loadSchool(code);
            this.setState({ showVideo: false, showDelayedVideo: false });
          },
          () => {
            this.setState({ loadingSurvey: undefined });
            window.alert("something went wrong");
          }
        );

      // load the school
      private loadSchool = (code: string): void =>
        void this.runCancellableStatefulAsync(
          this,
          {},
          {},
          async () => {
            const { responseSource } = this.props;
            const school = await this.buildGet<ISanitizedSchool & {id : number} | undefined>(
              this,
              `school/respondent/${responseSource}/${code}`
            )();
            if (school === undefined) {
              return;
            }
            console.log("schooldata", school)
            const { primaryColor, secondaryColor } = school;
            if (primaryColor !== "" && secondaryColor !== "") {
              // setTheme({
              //   palette: {
              //     primary: {
              //       main: primaryColor,
              //     },
              //     secondary: {
              //       main: secondaryColor,
              //     },
              //   },
              // });
            }
            this.setState({
              school: {
                logo1: school.logo1,
                logo2: school.logo2,
                name: school.name,
                tagline: school.tagline,
                mascot:school?.mascot,
                id:school?.id

              },
            });
          },
          () => {
            // window.alert('School failed to load');
          }
        );

      private getCollectRespondentName() {
        const { responseSource } = this.props;
        switch (responseSource) {
          case ResponseSource.parent:
          case ResponseSource.student:
            return true;
          default:
            return false;
        }
      }
    }
  )
);



// WEBPACK FOOTER //
// ./src/pages/RespondentPage.tsx